import { render, staticRenderFns } from "./FaturaReturn.vue?vue&type=template&id=e2b33408&scoped=true"
import script from "./FaturaReturn.vue?vue&type=script&lang=js"
export * from "./FaturaReturn.vue?vue&type=script&lang=js"
import style0 from "./FaturaReturn.vue?vue&type=style&index=0&id=e2b33408&prod&scoped=true&lang=css"
import style1 from "./FaturaReturn.vue?vue&type=style&index=1&id=e2b33408&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b33408",
  null
  
)

export default component.exports